<!-- VIEW: PERFIS (SIDEBAR LIST + EMBEDDED FORM) -->
<div
    class="flex-1 bg-slate-50 p-4 h-[calc(100vh-theme(spacing.20))] overflow-hidden flex flex-col md:flex-row gap-4 animate-fade-in relative">

    <!-- SIDEBAR: LISTA DE PERFIS -->
    <div
        class="w-full md:w-80 lg:w-96 shrink-0 bg-white rounded-2xl shadow-sm border border-slate-200 flex flex-col overflow-hidden h-1/3 md:h-full relative">

        <!-- Loading Overlay Sidebar -->
        <div *ngIf="mrpService.isLoading()"
            class="absolute inset-0 bg-white/60 backdrop-blur-sm z-50 flex items-center justify-center transition-opacity duration-300">
            <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600"></div>
        </div>

        <!-- Header Lista -->
        <div class="p-4 border-b border-slate-100 bg-white z-10">
            <div class="flex justify-between items-center mb-4">
                <h2 class="text-lg font-bold text-slate-800 flex items-center gap-2">
                    <lucide-icon [img]="icons.Layers" class="w-5 h-5 text-indigo-600"></lucide-icon> Perfis MRP
                </h2>
                <button (click)="newProfile()"
                    class="p-2 bg-indigo-50 text-indigo-600 rounded-lg hover:bg-indigo-100 transition-colors"
                    title="Novo Perfil">
                    <lucide-icon [img]="icons.Plus" class="w-5 h-5"></lucide-icon>
                </button>
            </div>
            <!-- Busca -->
            <div class="relative">
                <div class="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400">
                    <lucide-icon [img]="icons.Search" class="w-4 h-4"></lucide-icon>
                </div>
                <input type="text" (input)="onSearch($event)"
                    class="w-full pl-9 pr-4 py-2 bg-slate-50 border border-slate-200 rounded-lg text-sm focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 outline-none transition-all placeholder:text-slate-400"
                    placeholder="Buscar perfil...">
            </div>
        </div>

        <!-- Lista Scrollable -->
        <div class="flex-1 overflow-y-auto p-2 space-y-1" [class.opacity-50]="mrpService.isLoading()">
            @for (profile of filteredProfiles(); track profile.id) {
            <div (click)="selectProfile(profile)"
                class="group flex items-center p-3 rounded-xl cursor-pointer border transition-all relative overflow-hidden bg-white border-transparent hover:bg-slate-50 hover:border-slate-200"
                [class.bg-indigo-50]="selectedProfileId() === profile.id"
                [class.border-indigo-200]="selectedProfileId() === profile.id">

                <div class="w-10 h-10 rounded-lg border flex items-center justify-center mr-3 shadow-sm shrink-0 group-hover:scale-110 transition-transform"
                    [class.bg-white]="selectedProfileId() !== profile.id"
                    [class.border-slate-100]="selectedProfileId() !== profile.id"
                    [class.text-slate-400]="selectedProfileId() !== profile.id"
                    [class.bg-indigo-100]="selectedProfileId() === profile.id"
                    [class.border-indigo-200]="selectedProfileId() === profile.id"
                    [class.text-indigo-600]="selectedProfileId() === profile.id">
                    <lucide-icon [img]="icons.Box" class="w-5 h-5"></lucide-icon>
                </div>
                <div class="flex-1 min-w-0">
                    <p class="text-sm font-bold truncate transition-colors"
                        [class.text-slate-700]="selectedProfileId() !== profile.id"
                        [class.text-indigo-900]="selectedProfileId() === profile.id">
                        {{ profile.TELA_1.HW2_CODIGO }}
                    </p>
                    <p class="text-xs truncate transition-colors"
                        [class.text-slate-500]="selectedProfileId() !== profile.id"
                        [class.text-indigo-600]="selectedProfileId() === profile.id">
                        {{ profile.name }}
                    </p>
                </div>

                <!-- Ações Hover (Delete) -->
                <button (click)="confirmDelete(profile.id, $event)"
                    class="opacity-0 group-hover:opacity-100 p-2 text-slate-400 hover:text-red-500 hover:bg-red-50 rounded-lg transition-all absolute right-2 bg-white/80 backdrop-blur-sm shadow-sm"
                    title="Excluir">
                    <lucide-icon [img]="icons.Trash" class="w-4 h-4"></lucide-icon>
                </button>
            </div>
            }
        </div>
    </div>

    <!-- MAIN CONTENT AREA (Right Side) -->
    <div
        class="flex-1 min-w-0 bg-white rounded-2xl shadow-sm border border-slate-200 flex flex-col relative overflow-hidden h-2/3 md:h-full">

        <!-- Loading Overlay Detail -->
        <div *ngIf="mrpService.isLoading()"
            class="absolute inset-0 bg-white/60 backdrop-blur-sm z-50 flex items-center justify-center transition-opacity duration-300">
            <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600"></div>
        </div>

        @if (selectedProfileId()) {
        <!-- Header Detalhe -->
        <div class="px-6 py-4 border-b border-slate-100 flex justify-between items-center bg-white z-10 shrink-0">
            <div class="min-w-0 flex-1 mr-4">
                <span
                    class="text-[10px] font-bold text-slate-500 uppercase tracking-widest mb-1 block flex items-center gap-2">
                    <span class="w-2 h-2 rounded-full" [class.bg-emerald-500]="selectedProfileId() === 'NEW'"
                        [class.bg-amber-500]="selectedProfileId() !== 'NEW'"></span>
                    {{ selectedProfileId() === 'NEW' ? 'CRIANDO NOVO REGISTRO' : 'EDITANDO REGISTRO' }}
                </span>
                <h2 class="text-xl font-bold text-slate-800 truncate">
                    {{ selectedProfileId() === 'NEW' ? 'Novo Perfil MRP' : profileForm.get('name')?.value }}
                </h2>
            </div>
            <div class="flex gap-2 shrink-0">
                <button (click)="selectedProfileId.set(null)"
                    class="px-4 py-2 text-sm font-bold text-slate-600 bg-slate-100 hover:bg-slate-200 rounded-xl transition-colors">
                    Cancelar
                </button>
                <button (click)="saveProfile()" [disabled]="profileForm.invalid || profileForm.pristine"
                    class="px-4 py-2 text-sm font-bold text-white bg-indigo-600 hover:bg-indigo-700 rounded-xl transition-colors shadow-lg shadow-indigo-200 flex items-center gap-2 disabled:opacity-50 disabled:shadow-none">
                    <lucide-icon [img]="icons.Save" class="w-4 h-4"></lucide-icon> <span class="hidden sm:inline">Salvar
                        Alterações</span>
                </button>
            </div>
        </div>

        <!-- Form Scrollable -->
        <div class="flex-1 overflow-y-auto p-6 bg-slate-50/30">
            <form [formGroup]="profileForm" class="space-y-5">

                <!-- ═══════════════════════════ IDENTIFICAÇÃO ═══════════════════════════ -->
                <div class="section-card">
                    <h3 class="section-title-main">
                        <lucide-icon [img]="icons.Box" class="w-4 h-4 text-indigo-500"></lucide-icon> Identificação
                    </h3>
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
                        <div formGroupName="TELA_1">
                            <label class="field-label">Código do Documento MRP</label>
                            <input formControlName="HW2_CODIGO" type="text" class="form-input font-mono bg-slate-50">
                        </div>
                        <div>
                            <label class="field-label">Nome do Perfil</label>
                            <input formControlName="name" type="text" class="form-input bg-slate-50">
                        </div>
                    </div>
                </div>

                <!-- ═══════════════════════════ PERÍODO E DATAS ═══════════════════════════ -->
                <div class="section-card">
                    <h3 class="section-title">
                        <lucide-icon [img]="icons.Calendar"
                            class="w-3.5 h-3.5 text-indigo-400 inline mr-1"></lucide-icon>
                        Período e Datas
                    </h3>
                    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                        <div>
                            <label class="field-label">Tipo de Período</label>
                            <select formControlName="periodType" class="form-select">
                                <option value="1">1 — Diário</option>
                                <option value="2">2 — Semanal</option>
                                <option value="3">3 — Quinzenal</option>
                                <option value="4">4 — Mensal</option>
                                <option value="5">5 — Semestral</option>
                            </select>
                        </div>
                        <div>
                            <label class="field-label">Nº de Períodos</label>
                            <input formControlName="numberOfPeriods" type="number" min="1" class="form-input">
                        </div>
                        <div class="relative group/tip">
                            <label class="field-label flex items-center gap-1.5">
                                Horizonte de Demanda (dias)
                                <span
                                    class="w-4 h-4 rounded-full bg-slate-200 text-slate-500 text-[9px] font-bold inline-flex items-center justify-center cursor-help relative">?
                                    <div
                                        class="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 hidden group-hover/tip:block z-50 pointer-events-none">
                                        <div
                                            class="bg-slate-800 text-white text-[10px] rounded-lg px-3 py-2 shadow-lg w-[220px] leading-relaxed font-normal">
                                            Quantidade de dias que serão adicionados a partir da data de início da
                                            demanda.
                                            <div
                                                class="absolute top-full left-1/2 -translate-x-1/2 w-2 h-2 bg-slate-800 rotate-45 -mt-1">
                                            </div>
                                        </div>
                                    </div>
                                </span>
                            </label>
                            <input formControlName="demandEndDate" type="number" min="1" class="form-input"
                                placeholder="Ex: 30">
                        </div>
                    </div>
                </div>

                <!-- ═══════════════════════════ PARÂMETROS DE CÁLCULO ═══════════════════════════ -->
                <div class="section-card">
                    <h3 class="section-title">
                        <lucide-icon [img]="icons.Settings"
                            class="w-3.5 h-3.5 text-indigo-400 inline mr-1"></lucide-icon>
                        Parâmetros de Cálculo
                    </h3>
                    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                        <div>
                            <label class="field-label">Sugestão de Alocação de Lote</label>
                            <select formControlName="allocationSuggestion" class="form-select">
                                <option value="1">1 — Sim</option>
                                <option value="2">2 — Não</option>
                            </select>
                        </div>
                        <div>
                            <label class="field-label">Cálculo de Lead Time</label>
                            <select formControlName="leadTime" class="form-select">
                                <option value="1">1 — Sem calendário</option>
                                <option value="2">2 — Dias corridos</option>
                                <option value="3">3 — Dias úteis</option>
                            </select>
                        </div>
                        <div>
                            <label class="field-label">Horizonte Firme</label>
                            <select formControlName="firmHorizon" class="form-select">
                                <option value="1">1 — Sim</option>
                                <option value="2">2 — Não</option>
                            </select>
                        </div>
                    </div>
                </div>

                <!-- ═══════════════════════════ ESTOQUE ═══════════════════════════ -->
                <div class="section-card">
                    <h3 class="section-title">
                        <lucide-icon [img]="icons.Package"
                            class="w-3.5 h-3.5 text-indigo-400 inline mr-1"></lucide-icon>
                        Configurações de Estoque
                    </h3>
                    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                        <div>
                            <label class="field-label">Estoque de Segurança</label>
                            <select formControlName="safetyStock" class="form-select">
                                <option value="1">1 — Sim</option>
                                <option value="2">2 — Não</option>
                            </select>
                        </div>
                        <div>
                            <label class="field-label">Ponto de Pedido</label>
                            <select formControlName="orderPoint" class="form-select">
                                <option value="1">1 — Sim</option>
                                <option value="2">2 — Não</option>
                            </select>
                        </div>
                        <div>
                            <label class="field-label">Estoque Bloqueado por Lote</label>
                            <select formControlName="blockedLot" class="form-select">
                                <option value="1">1 — Subtrai</option>
                                <option value="2">2 — Mantém</option>
                            </select>
                        </div>
                        <div>
                            <label class="field-label">Estoque DE Terceiro</label>
                            <select formControlName="consignedIn" class="form-select">
                                <option value="1">1 — Subtrai</option>
                                <option value="2">2 — Mantém</option>
                            </select>
                        </div>
                        <div>
                            <label class="field-label">Estoque EM Terceiro</label>
                            <select formControlName="consignedOut" class="form-select">
                                <option value="1">1 — Soma</option>
                                <option value="2">2 — Não soma</option>
                            </select>
                        </div>
                        <div>
                            <label class="field-label">Estoque Rejeitado CQ</label>
                            <select formControlName="rejectedQuality" class="form-select">
                                <option value="1">1 — Subtrai</option>
                                <option value="2">2 — Mantém</option>
                            </select>
                        </div>
                    </div>
                </div>

                <!-- ═══════════════════════════ DOCUMENTOS E OP/SC ═══════════════════════════ -->
                <div class="section-card">
                    <h3 class="section-title">
                        <lucide-icon [img]="icons.FileText"
                            class="w-3.5 h-3.5 text-indigo-400 inline mr-1"></lucide-icon>
                        Documentos / OP / SC
                    </h3>
                    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                        <div>
                            <label class="field-label">Consolidar OP</label>
                            <select formControlName="consolidateProductionOrder" class="form-select">
                                <option value="1">1 — Aglutina</option>
                                <option value="2">2 — Não aglutina</option>
                                <option value="3">3 — Somente demandas</option>
                            </select>
                        </div>
                        <div>
                            <label class="field-label">Consolidar SC</label>
                            <select formControlName="consolidatePurchaseRequest" class="form-select">
                                <option value="1">1 — Aglutina</option>
                                <option value="2">2 — Não aglutina</option>
                                <option value="3">3 — Somente demandas</option>
                            </select>
                        </div>
                        <div>
                            <label class="field-label">Incrementa Nº OP</label>
                            <select formControlName="productionOrderNumber" class="form-select">
                                <option value="1">1 — Por item</option>
                                <option value="2">2 — Por número</option>
                            </select>
                        </div>
                        <div>
                            <label class="field-label">Gerar Documentos</label>
                            <select formControlName="productionOrderType" class="form-select">
                                <option value="1">1 — Previstos</option>
                                <option value="2">2 — Firmes</option>
                            </select>
                        </div>
                        <div>
                            <label class="field-label">Incrementa Nº SC</label>
                            <select formControlName="purchaseRequestNumber" class="form-select">
                                <option value="1">1 — Por item</option>
                                <option value="2">2 — Por número</option>
                            </select>
                        </div>
                    </div>
                </div>

                <!-- ═══════════════════════════ ARMAZÉM ═══════════════════════════ -->
                <div class="section-card">
                    <h3 class="section-title">Armazéns</h3>
                    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                        <div>
                            <label class="field-label">Só Armazém Padrão</label>
                            <select formControlName="armazemPad" class="form-select">
                                <option value="1">1 — Sim</option>
                                <option value="2">2 — Não</option>
                            </select>
                        </div>
                        <div>
                            <label class="field-label">Armazém (De)</label>
                            <input formControlName="armazemDe" type="text" class="form-input font-mono"
                                placeholder="Ex: 01">
                        </div>
                        <div>
                            <label class="field-label">Armazém (Até)</label>
                            <input formControlName="armazemAte" type="text" class="form-input font-mono"
                                placeholder="Ex: 99">
                        </div>
                        <div>
                            <label class="field-label">Seletivo de Armazéns</label>
                            <input formControlName="warehouses" type="text" class="form-input font-mono"
                                placeholder="Separar por |">
                            <span class="field-hint">Separar por PIPE ( | )</span>
                        </div>
                    </div>
                </div>

                <!-- ═══════════════════════════ SETUP ═══════════════════════════ -->
                <div class="section-card">
                    <h3 class="section-title">Setup de Configuração</h3>
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                            <label class="field-label">Código do Setup</label>
                            <input formControlName="setupCode" type="text" class="form-input font-mono">
                        </div>
                        <div>
                            <label class="field-label">Descrição do Setup</label>
                            <input formControlName="setupDescription" type="text" class="form-input">
                        </div>
                    </div>
                </div>

                <!-- ═══════════════════════════ FORNECEDOR ═══════════════════════════ -->
                <div class="section-card">
                    <h3 class="section-title">Fornecedor</h3>
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                            <label class="field-label">Código do Fornecedor</label>
                            <input formControlName="supplierCode" type="text" class="form-input font-mono"
                                placeholder="Ex: 000001">
                        </div>
                        <div>
                            <label class="field-label">Loja do Fornecedor</label>
                            <input formControlName="supplierStore" type="text" class="form-input font-mono"
                                placeholder="Ex: 01">
                        </div>
                    </div>
                </div>

                <!-- ═══════════════════════════ FLAGS DE PROCESSAMENTO ═══════════════════════════ -->
                <div class="grid grid-cols-1 lg:grid-cols-2 gap-5">
                    <div class="section-card">
                        <h3 class="section-title">
                            <lucide-icon [img]="icons.ToggleLeft"
                                class="w-3.5 h-3.5 text-indigo-400 inline mr-1"></lucide-icon>
                            Flags de Processamento
                        </h3>
                        <div class="space-y-3">
                            <!-- demandsProcessed -->
                            <div class="flex items-center justify-between p-2 rounded-lg hover:bg-slate-50 transition-colors cursor-pointer"
                                (click)="toggleFormControl('demandsProcessed')">
                                <div>
                                    <p class="text-sm font-medium text-slate-700">Considerar demandas já processadas</p>
                                </div>
                                <div class="toggle-track" [class.active]="profileForm.get('demandsProcessed')?.value">
                                    <div class="toggle-knob"></div>
                                </div>
                            </div>
                            <!-- eventLog -->
                            <div class="flex items-center justify-between p-2 rounded-lg hover:bg-slate-50 transition-colors cursor-pointer"
                                (click)="toggleFormControl('eventLog')">
                                <div>
                                    <p class="text-sm font-medium text-slate-700">Gerar log de eventos</p>
                                </div>
                                <div class="toggle-track" [class.active]="profileForm.get('eventLog')?.value">
                                    <div class="toggle-knob"></div>
                                </div>
                            </div>
                            <!-- lGeraDoc -->
                            <div class="flex items-center justify-between p-2 rounded-lg hover:bg-slate-50 transition-colors cursor-pointer"
                                (click)="toggleFormControl('lGeraDoc')">
                                <div>
                                    <p class="text-sm font-medium text-slate-700">Gerar documentos ao término</p>
                                </div>
                                <div class="toggle-track" [class.active]="profileForm.get('lGeraDoc')?.value">
                                    <div class="toggle-knob"></div>
                                </div>
                            </div>
                            <!-- lRastreiaEntradas -->
                            <div class="flex items-center justify-between p-2 rounded-lg hover:bg-slate-50 transition-colors cursor-pointer"
                                (click)="toggleFormControl('lRastreiaEntradas')">
                                <div>
                                    <p class="text-sm font-medium text-slate-700">Rastreabilidade de entradas</p>
                                </div>
                                <div class="toggle-track" [class.active]="profileForm.get('lRastreiaEntradas')?.value">
                                    <div class="toggle-knob"></div>
                                </div>
                            </div>
                            <!-- lDocAlcada -->
                            <div class="flex items-center justify-between p-2 rounded-lg hover:bg-slate-50 transition-colors cursor-pointer"
                                (click)="toggleFormControl('lDocAlcada')">
                                <div>
                                    <p class="text-sm font-medium text-slate-700">Alçada de aprovação para SCs</p>
                                </div>
                                <div class="toggle-track" [class.active]="profileForm.get('lDocAlcada')?.value">
                                    <div class="toggle-knob"></div>
                                </div>
                            </div>
                            <!-- doTransfersMrp -->
                            <div class="flex items-center justify-between p-2 rounded-lg hover:bg-slate-50 transition-colors cursor-pointer"
                                (click)="toggleFormControl('doTransfersMrp')">
                                <div>
                                    <p class="text-sm font-medium text-slate-700">Transferências entre filiais</p>
                                </div>
                                <div class="toggle-track" [class.active]="profileForm.get('doTransfersMrp')?.value">
                                    <div class="toggle-knob"></div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- ═══════════════════════════ TIPOS DE DEMANDA ═══════════════════════════ -->
                    <div class="section-card" formGroupName="demandType">
                        <h3 class="section-title">Tipos de Demanda</h3>
                        <div class="space-y-3">
                            <div class="flex items-center justify-between p-2 rounded-lg hover:bg-slate-50 transition-colors cursor-pointer"
                                (click)="toggleFormControl('demandType.PEDIDO_VENDA')">
                                <p class="text-sm font-medium text-slate-700">Pedido de Venda</p>
                                <div class="toggle-track"
                                    [class.active]="profileForm.get('demandType.PEDIDO_VENDA')?.value">
                                    <div class="toggle-knob"></div>
                                </div>
                            </div>
                            <div class="flex items-center justify-between p-2 rounded-lg hover:bg-slate-50 transition-colors cursor-pointer"
                                (click)="toggleFormControl('demandType.PREV_VENDAS')">
                                <p class="text-sm font-medium text-slate-700">Previsão de Vendas</p>
                                <div class="toggle-track"
                                    [class.active]="profileForm.get('demandType.PREV_VENDAS')?.value">
                                    <div class="toggle-knob"></div>
                                </div>
                            </div>
                            <div class="flex items-center justify-between p-2 rounded-lg hover:bg-slate-50 transition-colors cursor-pointer"
                                (click)="toggleFormControl('demandType.PLANO_MESTRE')">
                                <p class="text-sm font-medium text-slate-700">Plano Mestre</p>
                                <div class="toggle-track"
                                    [class.active]="profileForm.get('demandType.PLANO_MESTRE')?.value">
                                    <div class="toggle-knob"></div>
                                </div>
                            </div>
                            <div class="flex items-center justify-between p-2 rounded-lg hover:bg-slate-50 transition-colors cursor-pointer"
                                (click)="toggleFormControl('demandType.EMP_PROJETO')">
                                <p class="text-sm font-medium text-slate-700">Empenho de Projeto</p>
                                <div class="toggle-track"
                                    [class.active]="profileForm.get('demandType.EMP_PROJETO')?.value">
                                    <div class="toggle-knob"></div>
                                </div>
                            </div>
                            <div class="flex items-center justify-between p-2 rounded-lg hover:bg-slate-50 transition-colors cursor-pointer"
                                (click)="toggleFormControl('demandType.MANUAL')">
                                <p class="text-sm font-medium text-slate-700">Demanda Manual</p>
                                <div class="toggle-track" [class.active]="profileForm.get('demandType.MANUAL')?.value">
                                    <div class="toggle-knob"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- ═══════════════════════════ TIPOS DE DOCUMENTO ═══════════════════════════ -->
                <div class="section-card" formGroupName="documentType">
                    <h3 class="section-title">Tipos de Documento</h3>
                    <div class="grid grid-cols-1 sm:grid-cols-3 gap-4 items-end">
                        <div>
                            <label class="field-label">Previstos</label>
                            <select formControlName="PREVISTOS" class="form-select">
                                <option value="1">1 — EXCLUI</option>
                                <option value="2">2 — NÃO EXCLUI</option>
                                <option value="3">3 — ENTRA NO MRP</option>
                            </select>
                        </div>
                        <div class="flex items-center justify-between p-2 rounded-lg hover:bg-slate-50 transition-colors cursor-pointer"
                            (click)="toggleFormControl('documentType.SACRAMENTADOS')">
                            <p class="text-sm font-medium text-slate-700">Sacramentados</p>
                            <div class="toggle-track"
                                [class.active]="profileForm.get('documentType.SACRAMENTADOS')?.value">
                                <div class="toggle-knob"></div>
                            </div>
                        </div>
                        <div class="flex items-center justify-between p-2 rounded-lg hover:bg-slate-50 transition-colors cursor-pointer"
                            (click)="toggleFormControl('documentType.SUSPENSOS')">
                            <p class="text-sm font-medium text-slate-700">Suspensos</p>
                            <div class="toggle-track" [class.active]="profileForm.get('documentType.SUSPENSOS')?.value">
                                <div class="toggle-knob"></div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- ═══════════════════════════ SELETIVOS ═══════════════════════════ -->
                <div class="section-card">
                    <h3 class="section-title">Seletivos (Listas)</h3>
                    <p class="text-xs text-slate-400 -mt-2 mb-4">Informe os valores separados por PIPE ( | )</p>
                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4">
                        <div formGroupName="demandCodes" class="flex flex-col">
                            <label class="field-label">Códigos de Demanda</label>
                            <textarea formControlName="LISTA" class="form-input font-mono text-xs flex-1 min-h-[80px]"
                                placeholder="Ex: COD1|COD2|COD3"></textarea>
                        </div>
                        <div formGroupName="documents" class="flex flex-col">
                            <label class="field-label">Documentos</label>
                            <textarea formControlName="LISTA" class="form-input font-mono text-xs flex-1 min-h-[80px]"
                                placeholder="Ex: DOC1|DOC2"></textarea>
                        </div>
                        <div formGroupName="productGroups" class="flex flex-col">
                            <label class="field-label">Grupos de Produto</label>
                            <textarea formControlName="LISTA" class="form-input font-mono text-xs flex-1 min-h-[80px]"
                                placeholder="Ex: GRP1|GRP2"></textarea>
                        </div>
                        <div formGroupName="products" class="flex flex-col">
                            <label class="field-label">Produtos</label>
                            <textarea formControlName="LISTA" class="form-input font-mono text-xs flex-1 min-h-[80px]"
                                placeholder="Ex: PROD1|PROD2"></textarea>
                        </div>
                        <div formGroupName="productTypes" class="flex flex-col">
                            <label class="field-label">Tipos de Produto</label>
                            <textarea formControlName="LISTA" class="form-input font-mono text-xs flex-1 min-h-[80px]"
                                placeholder="Ex: PA|MP|PI"></textarea>
                        </div>
                    </div>
                </div>

            </form>
        </div>
        } @else {
        <div class="h-full flex flex-col items-center justify-center text-slate-400">
            <lucide-icon [img]="icons.Layers" class="w-16 h-16 mb-4 opacity-20"></lucide-icon>
            <p class="text-lg font-medium text-slate-500">Selecione um perfil para editar</p>
            <p class="text-sm text-slate-400 max-w-xs text-center mt-2">Escolha um perfil da lista à esquerda ou crie um
                novo para visualizar suas configurações.</p>
        </div>
        }
    </div>
</div>

<!-- MODAL DELETE CONFIRMATION -->
@if (profileToDeleteId()) {
<div class="fixed inset-0 bg-slate-900/40 backdrop-blur-sm z-50 flex items-center justify-center p-4 animate-fade-in">
    <div class="bg-white rounded-2xl shadow-2xl max-w-sm w-full p-6 overflow-hidden">
        <div class="flex items-center gap-4 mb-4">
            <div class="w-12 h-12 rounded-full bg-red-100 flex items-center justify-center text-red-600 shrink-0">
                <lucide-icon [img]="icons.AlertCircle" class="w-6 h-6"></lucide-icon>
            </div>
            <h3 class="text-lg font-bold text-slate-800">Excluir Perfil?</h3>
        </div>
        <p class="text-sm text-slate-600 mb-8 leading-relaxed">
            Esta ação não pode ser desfeita. O perfil será removido permanentemente do sistema.
        </p>
        <div class="flex justify-end gap-3">
            <button (click)="cancelDelete()"
                class="px-4 py-2 text-sm font-medium text-slate-600 bg-slate-100 hover:bg-slate-200 rounded-lg transition-colors">
                Cancelar
            </button>
            <button (click)="deleteProfile()"
                class="px-4 py-2 text-sm font-medium text-white bg-red-600 hover:bg-red-700 rounded-lg transition-colors shadow-sm flex items-center gap-2">
                <lucide-icon [img]="icons.Trash" class="w-3.5 h-3.5"></lucide-icon> Sim, Excluir
            </button>
        </div>
    </div>
</div>
}